<form #featureForm="ngForm" (ngSubmit)="onSubmit(featureForm)" class="container" *ngIf="feature">
  <div class="form-group">
    <label for="name">Feature Name</label>
    <input type="text" class="form-control" id="name" name="name" [(ngModel)]="feature.name" required>
  </div>
  <div class="form-group">
    <label for="displayName">Display Name</label>
    <input type="text" class="form-control" id="displayName" name="displayName" [(ngModel)]="feature.displayName"
           required>
  </div>
  <div class="form-check">
    <input type="checkbox" class="form-check-input" id="enabled" name="enabled" [(ngModel)]="feature.enabled">
    <label for="enabled" class="form-check-label">Enabled</label>
  </div>
  <div class="form-check">
    <input type="checkbox" class="form-check-input" id="enabledPerDistrict" name="enabledPerDistrict"
           [(ngModel)]="feature.enabledPerDistrict">
    <label for="availableToDistricts" class="form-check-label">Enabled Per District</label>
  </div>
  <div class="form-check">
    <input type="checkbox" class="form-check-input" id="enabledPerStaff" name="enabledPerStaff"
           [(ngModel)]="feature.enabledPerStaff">
    <label for="defaultDistrictValue" class="form-check-label">Enabled Per Staff</label>
  </div>

  <!-- Districts list section -->
  <div *ngIf="feature!.enabledPerDistrict" class="mt-3">
    <h4>Districts</h4>
    <div class="list-group">
      <div *ngFor="let district of districts" class="list-group-item">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ district.name }}</span>
          <!-- You might want to add checkboxes or other controls here to manage per-district settings -->
        </div>
      </div>
    </div>
  </div>

  <button type="submit" class="btn btn-primary mt-3">Submit</button>
</form>
